<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :height="props.size"
      :width="props.size" 
      :fill="props.fillColor" 
      class="material-design-icon__svg" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg">
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M3 2.99994H21C22.1 2.99994 23 3.88994 23 4.99994L22.99 17C22.99 18.1 22.1 19 21 19H16V21H8V19H3C1.89 19 1 18.1 1 17V4.99994C1 3.88994 1.89 2.99994 3 2.99994ZM3 16.9998H21V4.99979H3V16.9998Z" 
        fill="#4A4A4A"/>
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M15 9.49997C15 10.8812 13.8813 12 12.5 12C11.1187 12 10 10.8812 10 9.49997C10 8.11872 11.1187 6.99997 12.5 6.99997C13.8813 6.99997 15 8.11872 15 9.49997ZM8 14.9998C8 13.6698 10.9981 12.9998 12.5 12.9998C14.0019 12.9998 17 13.6698 17 14.9998V15.9998H8V14.9998Z" 
        fill="#4A4A4A"/>
    </svg>
    
  </span>
</template>

<script>
export default {
  name: "VideoConference",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/VideoConference.vue